import React from 'react';
import {
  ListGroupItem,
} from 'reactstrap';
import PropTypes from 'prop-types';

const hexToRgb = (hex, opacity) => {
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
};

const getCorrectTextColor = (hex) => {
  /*
  From this W3C document: http://www.webmasterworld.com/r.cgi?f=88&d=9769&url=http://www.w3.org/TR/AERT#color-contrast

  Color brightness is determined by the following formula:
  ((Red value X 299) + (Green value X 587) + (Blue value X 114)) / 1000

  I know this could be more compact, but I think this is easier to read/explain.

  */

  let threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */

  function cutHex(h) { return (h.charAt(0) === '#') ? h.substring(1, 7) : h; }
  function hexToR(h) { return parseInt((cutHex(h)).substring(0, 2), 16); }
  function hexToG(h) { return parseInt((cutHex(h)).substring(2, 4), 16); }
  function hexToB(h) { return parseInt((cutHex(h)).substring(4, 6), 16); }

  let hRed = hexToR(hex);
  let hGreen = hexToG(hex);
  let hBlue = hexToB(hex);

  let cBrightness = ((hRed * 299) + (hGreen * 587) + (hBlue * 114)) / 1000;
  if (cBrightness > threshold) { return '#000000'; } return '#ffffff';
};

const TermekcsoportItem = (props) => {
  const {
    children,
    szinkod,
    ...attrs
  } = props;
  return (
    <ListGroupItem
      {...attrs}
      action
      className="noselect"
      style={{
        backgroundColor: hexToRgb(props.szinkod, 100),
        color: getCorrectTextColor(props.szinkod),
        padding: 26,
        cursor: 'pointer',
        fontSize: 20,
        fontWeight: 'bold',
        paddingTop: '10px',
        paddingBottom: '10px',
        paddingLeft: '10px',
        marginBottom: '4px',
        wordBreak: "break-all"
      }}
    >
      {props.children}
    </ListGroupItem>
  );
};

TermekcsoportItem.propTypes = {
  szinkod: PropTypes.string,
  children: PropTypes.string,
};

export default TermekcsoportItem;
